<template>
    <Head title="Dashboard" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="relative w-full py-12 my-6 overflow-hidden shadow">
            <div class="px-2 md:px-6 pt-2 md:pt-4 pb-2">
                <div class="overflow-x-auto">
                    <div class="grid xl:grid-cols-2 gap-4">
                        <AdminWebsite v-for="website in websites" :website="website" />
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue'
import { Head } from '@inertiajs/inertia-vue3';
import AdminWebsite from "@/Components/Admin/AdminWebsite";

export default {
    components: {
        AdminWebsite,
        BreezeAuthenticatedLayout,
        Head,
    },
    props:
    {
        websites: Object
    }
}
</script>
